module.exports = __webpack_public_path__ + "images/emoji/bug.bdbb18cd6c0be40bbcbc.png";